import { forwardRef, memo } from 'react';
// Skillmore UI Components
import useDragAndDropItem, { type MoveItemFunction } from '@empathco/ui-components/src/hooks/useDragAndDropItem';
import useCombinedRefs from '@empathco/ui-components/src/hooks/useCombinedRefs';
// local imports
import { Employee } from '../models/employee';
import EmployeeCard, { AvatarVariant, MatchRateVariant } from './EmployeeCard';

export type EmployeeDraggableCardProps = {
  readonly item: Employee;
  readonly moveEmployee: MoveItemFunction;
  readonly withSkills?: boolean | null;
  readonly matchRateVariant?: MatchRateVariant;
  readonly avatarVariant?: AvatarVariant;
  readonly route?: string | null;
  readonly disabled?: boolean | null;
  readonly pending?: boolean | null;
  readonly onAction?: (id: number) => unknown;
  readonly actionLabel?: string;
  readonly withZoomInSkills?: boolean;
};

const EmployeeDraggableCard = forwardRef<HTMLDivElement, EmployeeDraggableCardProps>(({
  item,
  moveEmployee,
  withSkills = false,
  matchRateVariant,
  avatarVariant,
  route,
  disabled = false,
  pending = false,
  onAction,
  actionLabel,
  withZoomInSkills = false
}, parentRef) => {
  const { ref, isDragging } = useDragAndDropItem(item.id, 'employee', moveEmployee, disabled);
  const cardRef = useCombinedRefs<HTMLDivElement>(parentRef, ref);
  return (
    <EmployeeCard
        ref={cardRef}
        item={item}
        draggable
        isDragging={isDragging}
        withSkills={withSkills}
        matchRateVariant={matchRateVariant}
        avatarVariant={avatarVariant}
        route={route}
        disabled={disabled}
        pending={pending}
        onAction={onAction}
        actionLabel={actionLabel}
        withZoomInSkills={withZoomInSkills}
    />
  );
});

EmployeeDraggableCard.displayName = 'EmployeeDraggableCard';

export default memo(EmployeeDraggableCard);
